export default class Reviews {
  constructor(http) {
    this.http = http;
  }

  // Définition du path
  path(shopId, productId, sortBy, pageSize, pageIndex) {
    if (sortBy && pageSize && pageIndex) {
      return `/api/magasins/${shopId}/produits/${productId}/reviews?page=${pageIndex}&page-size=${pageSize}&sort-by=${sortBy}`
    } else {
      return `/api/magasins/${shopId}/produits/${productId}/reviews`
    }
  }

  async reviews(params) {
    const response = await this.http.get(this.path(params.shopId, params.productId, params.sortBy, params.pageSize, params.pageIndex));
    return response.data;
  }
}
